import "./seeker.css";
import amc_logo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import { FaAngleLeft, FaClock } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function SeekerInfo() {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [turnsAwait, setTurnsAwait] = useState(0);
  const [seekerArr, setSeekerArr] = useState([]);
  const [currentSeeker, setCurrentSeeker] = useState({});
  const [statusModal, setStatusModal] = useState({ status: false, modal: "" });

  const navigate = useNavigate();

  const getTurns = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/search/turn_await`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });
      setTurnsAwait(response.data.data.turns_await);
    } catch (error) {
      console.error("error");
    }
  };

  const getSeekers = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/search`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });

      setSeekerArr(response.data.turns);
    } catch (error) {
      console.error("error", error);
      Swal.fire({
        title: "Error",
        text: "Ocurrio un error al mostrar los datos.",
        icon: "error",
      });
    }
  };

  const setBg = (bg, status) => {
    if (bg === "status") {
      switch (status) {
        case "1":
          return "seek-bg-blue";
        case "2":
          return "seek-bg-green";
        case "3":
          return "seek-bg-orange";
        case "4":
          return "seek-bg-red";
        default:
          return "seek-bg-blue";
          break;
      }
    }
  };

  const getTextStatus = (status) => {
    switch (status) {
      case "1":
        return "Buscando";
      case "2":
        return "Encontrado";
      case "3":
        return "Encontrado parcial";
      case "4":
        return "No encontrado";
      default:
        return "";
    }
  };

  const logOut = async() => {
    const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/user/logout`;
    const body = {
      user_id: localStorage.getItem("collection-email"),
      profile: localStorage.getItem("collection-profile"),
    };

    await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
      },
    });
    localStorage.clear();
    navigate("/amc-domestico/collection/");
  };

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    getTurns();
    getSeekers();
  }, []);

  return (
    <>
      <div className="seeker-container">
        <div className="seeker-header">
          <img src={amc_logo} alt="Aeromexico" />
        </div>

        <div className="info-content">
          <p>{currentDate}</p>
          <p>{currentTime}</p>
          <div className="return-content">
            <FaAngleLeft onClick={logOut} />
          </div>
        </div>

        <div className="seeker-body">
          <h3>Turnos asignados</h3>

          <div className="turns-content" style={{ justifyContent: "center" }}>
            <div className="wait-turn">
              <FaClock />
              <p>Turnos en espera</p>
              <div className="turn-number">{turnsAwait}</div>
            </div>
          </div>

          {seekerArr.length !== 0 ? (
            <table className="table-format">
              <thead>
                <tr>
                  <th className="text-center">Turno</th>
                  <th className="text-center">
                    Nombre de empleado/# de empleado
                  </th>
                  <th className="text-center">Estatus</th>
                </tr>
              </thead>
              <tbody>
                {seekerArr.map((seeker, index) => (
                  <tr key={index}>
                    <td className="borderStyle text-center">
                      {seeker.turn_number}
                    </td>
                    <td className="borderStyle text-center">
                      {seeker.employee_name} {seeker.turn} (
                      {seeker.employee_number})
                    </td>
                    <td className="borderLastStyle text-center">
                      <div
                        className={`seeker-status-text ${setBg(
                          "status",
                          seeker.status
                        )}`}
                      >
                        {getTextStatus(seeker.status)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="not-turn-register-text">
              <p>Sin turnos registrados</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default SeekerInfo;
